import PrefixEnum from '../prefixes'

export default Object.freeze({
    'www.machdichkrass.de': PrefixEnum.DANIEL_AMINATI,
    'machdichkrass.de': PrefixEnum.DANIEL_AMINATI,
    'www.machdichkrass.com': PrefixEnum.DANIEL_AMINATI,
    'machdichkrass.com': PrefixEnum.DANIEL_AMINATI,
})
